/** @jsx builderX.jsx */
import { builderX, Sprite, Image, Text, Button } from '@gongxigames/framework/core/fragments/BuilderX';

export default <Sprite position={[0, -130]} name='bonus'>
    <Image position={[312, 100]} name='bonus_bg' src='bonus_bg'/>
    <Sprite name='fg_segment2'>
        <Sprite name='diamonds'>
            <Sprite name='whiteDiamond1'>
                <Image position={[2408, 330]} scale={[0.5, 0.5]} name='whiteDiamond1' src='white-diamond'/>
                <Sprite position={[2408, 330]} name='animationContainer'/>
            </Sprite>
            <Sprite name='whiteDiamond2'>
                <Image position={[2349, 471]} scale={[0.5, 0.5]} name='whiteDiamond2' src='white-diamond'/>
                <Sprite position={[2349, 471]} name='animationContainer'/>
            </Sprite>
            <Sprite name='whiteDiamond3'>
                <Image position={[2409, 616]} scale={[0.5, 0.5]} name='whiteDiamond3' src='white-diamond'/>
                <Sprite position={[2409, 616]} name='animationContainer'/>
            </Sprite>
        </Sprite>
        <Text position={[2830, 286]} style={{
            fontFamily: 'Arial',
            fontSize: 140,
            fontStyle: 'normal',
            fill: '#000000',
            align: 'center',
            fontWeight: 'normal'
        }} name='FGAmount' localeTextID='' text='10'/>
        <Text position={[2660, 363]} style={{
            fontFamily: 'Arial',
            fontSize: 80,
            fontStyle: 'normal',
            fill: '#000000',
            align: 'center',
            fontWeight: 'normal'
        }} maxWidth={530} name='FGText' localeTextID='' text='FREE GAMES'/>
        <Text position={[2768, 661]} style={{
            fontFamily: 'Arial',
            fontSize: 60,
            fontStyle: 'normal',
            fill: '#000000',
            align: 'center',
            fontWeight: 'normal'
        }} maxWidth={302} name='RemovedText' localeTextID='' text='REMOVED'/>
        <Sprite position={[2815, 520]} name='animationContainer'/>
    </Sprite>
    <Sprite name='fg_segment1'>
        <Sprite name='diamonds'>
            <Sprite name='greenDiamond1'>
                <Image position={[2407, 865]} scale={[0.5, 0.5]} name='greenDiamond1' src='green-diamond'/>
                <Sprite position={[2407, 865]} name='aniamtionContainer'/>
            </Sprite>
            <Sprite name='greenDiamond2'>
                <Image position={[2348, 1008]} scale={[0.5, 0.5]} name='greenDiamond2' src='green-diamond'/>
                <Sprite position={[2348, 1008]} name='aniamtionContainer'/>
            </Sprite>
            <Sprite name='greenDiamond3'>
                <Image position={[2407, 1151]} scale={[0.5, 0.5]} name='greenDiamond3' src='green-diamond'/>
                <Sprite position={[2407, 1151]} name='aniamtionContainer'/>
            </Sprite>
        </Sprite>
        <Text position={[2830, 822]} style={{
            fontFamily: 'Arial',
            fontSize: 140,
            fontStyle: 'normal',
            fill: '#000000',
            align: 'center',
            fontWeight: 'normal'
        }} name='FGAmount' localeTextID='' text='10'/>
        <Text position={[2660, 899]} style={{
            fontFamily: 'Arial',
            fontSize: 80,
            fontStyle: 'normal',
            fill: '#000000',
            align: 'center',
            fontWeight: 'normal'
        }} maxWidth={530} name='FGText' localeTextID='' text='FREE GAMES'/>
        <Text position={[2768, 1198]} style={{
            fontFamily: 'Arial',
            fontSize: 60,
            fontStyle: 'normal',
            fill: '#000000',
            align: 'center',
            fontWeight: 'normal'
        }} maxWidth={302} name='RemovedText' localeTextID='' text='REMOVED'/>
        <Sprite position={[2815, 1060]} name='animationContainer'/>
    </Sprite>
    <Sprite name='fg_segment0'>
        <Sprite name='diamonds'>
            <Sprite name='blueDiamond1'>
                <Image position={[2461, 1382]} scale={[0.5, 0.5]} name='blueDiamond1' src='blue-diamond'/>
                <Sprite position={[2461, 1382]} name='aniamtionContainer'/>
            </Sprite>
            <Sprite name='blueDiamond2'>
                <Image position={[2343, 1464]} scale={[0.5, 0.5]} name='blueDiamond2' src='blue-diamond'/>
                <Sprite position={[2343, 1464]} name='aniamtionContainer'/>
            </Sprite>
            <Sprite name='blueDiamond3'>
                <Image position={[2344, 1607]} scale={[0.5, 0.5]} name='blueDiamond3' src='blue-diamond'/>
                <Sprite position={[2344, 1607]} name='aniamtionContainer'/>
            </Sprite>
            <Sprite name='blueDiamond4'>
                <Image position={[2462, 1694]} scale={[0.5, 0.5]} name='blueDiamond4' src='blue-diamond'/>
                <Sprite position={[2462, 1694]} name='aniamtionContainer'/>
            </Sprite>
        </Sprite>
        <Text position={[2830, 1465]} style={{
            fontFamily: 'Arial',
            fontSize: 140,
            fontStyle: 'normal',
            fill: '#000000',
            align: 'center',
            fontWeight: 'normal'
        }} name='FGAmount' localeTextID='' text='10'/>
        <Text position={[2660, 1545]} style={{
            fontFamily: 'Arial',
            fontSize: 80,
            fontStyle: 'normal',
            fill: '#000000',
            align: 'center',
            fontWeight: 'normal'
        }} maxWidth={530} name='FGText' localeTextID='' text='FREE GAMES'/>
        <Sprite position={[2815, 1600]} name='animationContainer'/>
    </Sprite>
    <Text position={[734, 202]} style={{
        fontFamily: 'Arial',
        fontSize: 120,
        fontStyle: 'normal',
        fill: '#000000',
        align: 'center',
        fontWeight: 'bolder'
    }} maxWidth={1300} name='pickText' localeTextID='' text='PICK A MEDALLION'/>
    <Button position={[330, 1585]} hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='autoPick'>
        <Sprite>
            <Image name='btn_back' src='autopick_normal'/>
            <Text position={[85, 116]} style={{
                fontFamily: 'Arial',
                fontSize: 50,
                fontStyle: 'normal',
                fill: '#FFFF00',
                align: 'center',
                fontWeight: 'normal'
            }} maxWidth={270} name='AutoPickText' localeTextID='' text='AUTO PICK'/>
        </Sprite>
        <Sprite>
            <Image name='btn_back' src='autopick_focused'/>
            <Text position={[85, 116]} style={{
                fontFamily: 'Arial',
                fontSize: 50,
                fontStyle: 'normal',
                fill: '#FFFF00',
                align: 'center',
                fontWeight: 'normal'
            }} maxWidth={270} name='AutoPickText' localeTextID='' text='AUTO PICK'/>
        </Sprite>
        <Sprite>
            <Image name='btn_back' src='autopick_pressed'/>
            <Text position={[85, 116]} style={{
                fontFamily: 'Arial',
                fontSize: 50,
                fontStyle: 'normal',
                fill: '#FFFF00',
                align: 'center',
                fontWeight: 'normal'
            }} maxWidth={270} name='AutoPickText' localeTextID='' text='AUTO PICK'/>
        </Sprite>
        <Sprite>
            <Image name='btn_back' src='autopick_disabled'/>
            <Text position={[85, 116]} style={{
                fontFamily: 'Arial',
                fontSize: 50,
                fontStyle: 'normal',
                fill: '#FFFF00',
                align: 'center',
                fontWeight: 'normal'
            }} maxWidth={270} name='AutoPickText' localeTextID='' text='AUTO PICK'/>
        </Sprite>
    </Button>
</Sprite>;
